// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Symbology } from '../pages/I.LAB';

function SymbologyRoutes(): ReactElement {
  return (
    <>
      <Route path="/ilab/symbology" exact component={Symbology.SymbologyList} />
      <Route
        path="/ilab/symbology/cadaster"
        exact
        component={Symbology.SymbologyCadaster}
      />
      <Route
        path="/ilab/symbology/edit/:symbologyId"
        exact
        component={Symbology.EditSymbology}
      />
    </>
  );
}

export default SymbologyRoutes;
